<div class="the_top">
  <div class="log"><h2 class="title">ADR</h2><div class="history"></div></div>
    <div class="filter_search">
      <div class="search_container">
        <input type="text" #search class="default_input search search_land" placeholder="Search"/>
        <em class="ti-search"></em> 
      </div>
      
    </div>
  </div>